import pino from 'pino';

export const rootLogger = pino({level: 'trace'});
